import styled from '@emotion/styled';
import FormattedText from '@/components/FormattedText';

const LevelDescription = styled(FormattedText)({
  marginTop: 0,
  marginBottom: 24,
});

export default LevelDescription;
